// extracted by mini-css-extract-plugin
module.exports = {"card":"MyInfo_card__m-sB7"};